import PublicLayout from '../../../components/public/PublicLayout';
import Hero from '../../../components/public/Hero';
import Icon from '../../../components/public/Icon';
import { Panel } from '../../../components/public/Common';
import { NoRealData } from '@/components/shared';
import { inspectionRequestSteps, inspectionRequestTopics } from '@/config/coletor-publico-config';

// O envio de solicitacao ainda nao existe (nao ha endpoint publico): o formulario
// foi retirado para nao simular um protocolo que nao e gravado.
export default function InspectionPage(){return <PublicLayout>
 <Hero title="Solicitar Vistoria" subtitle="Conte com a Prefeitura de Goiânia para uma cidade mais verde e segura." description="Solicitação de vistoria de árvores e áreas verdes. A equipe técnica analisa cada pedido e orienta o cidadão." />
 <div className="page-pad">
  <div className="steps">{inspectionRequestSteps.map(([n,t,d,icon])=><div key={n}><b>{n}</b><Icon name={icon}/><span><strong>{t}</strong><small>{d}</small></span></div>)}</div>
  <div className="grid gap-3 md:grid-cols-[2fr_1fr] mt-3">
   <NoRealData variant="page" title="Solicitação online de vistoria" description="O envio de solicitações e o acompanhamento de protocolo pelo portal ainda não estão disponíveis. Procure os canais oficiais de atendimento da Prefeitura." icon="ri-clipboard-line"/>
   <Panel title="Quando solicitar" icon="info"><ul className="link-list">{inspectionRequestTopics.map(t=><li key={t}>{t}</li>)}</ul></Panel>
  </div>
 </div>
 </PublicLayout>}
